module.exports = __webpack_public_path__ + "img/gb70.prt.2fd53087.jpg";